<template>
  <div>
    <el-card class="box-card" v-if="!recon.show">
      <div slot="header" class="flex justify-between">
        <span>商品信息</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_openDownloadHcExcelTemplate">
          <i class="el-icon-download"></i>模板
        </el-button>
      </div>

      <el-form label-position="left" label-width="120px" class="text-left">
        <el-form-item label="选择文件">
          <el-upload class="upload-demo" ref="upload" action="#" :auto-upload="false" :on-change="getExcelTemplate"
            :file-list="fileList" accept=".xls,.xlsx">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ productImportInfo.excelTemplate === '' ? '必填，请选择数据文件（Excel ≤20M）' : productImportInfo.excelTemplate.name }}
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="图片压缩包">
          <el-upload class="upload-demo" ref="zipUpload" action="#" :auto-upload="false" :on-change="getZipFile"
            :on-remove="removeZipFile" :file-list="zipFileList" accept=".zip">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              {{ productImportInfo.zipFile === '' ? '商品图片压缩包，选填。命名规则见模板填写说明（zip ≤500M）' : productImportInfo.zipFile.name }}
            </div>
          </el-upload>
        </el-form-item>

        <el-form-item label="备注">
          <el-input type="textarea" v-model="productImportInfo.remark" placeholder="请填写备注信息" :rows="3"></el-input>
        </el-form-item>
      </el-form>
    </el-card>

    <el-row v-if="!recon.show">
      <el-col :span="22"></el-col>
      <el-col :span="2" class="import-btn-col">
        <el-button type="primary" @click="_importData" :loading="importing" :disabled="importing"
          style="margin-bottom: 10px; float: right">
          <i class="el-icon-upload"></i>导入
        </el-button>
      </el-col>
    </el-row>

    <!-- 历史导入批次：商家直接看本店全部批次，点击详情复用对账视图 -->
    <el-card v-if="!recon.show" class="box-card margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>历史导入批次</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_queryHistory(history.page)">
          <i class="el-icon-refresh"></i>刷新
        </el-button>
      </div>
      <el-table ref="historyTable" :data="history.list" border style="width: 100%" size="small" v-loading="history.loading">
        <el-table-column prop="logId" label="批次号" align="center" width="180"></el-table-column>
        <el-table-column label="状态" align="center" width="90">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.state === 'W'" type="info" size="small">待处理</el-tag>
            <el-tag v-else-if="scope.row.state === 'D'" type="warning" size="small">处理中</el-tag>
            <el-tag v-else-if="scope.row.state === 'C'" type="success" size="small">完成</el-tag>
            <span v-else>{{ scope.row.state || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="successCount" label="成功" align="center" width="70"></el-table-column>
        <el-table-column prop="errorCount" label="失败" align="center" width="70"></el-table-column>
        <el-table-column prop="skipCount" label="跳过" align="center" width="70"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center" width="170"></el-table-column>
        <el-table-column label="操作" align="center" min-width="90">
          <template slot-scope="scope">
            <el-button size="mini" @click="_viewHistoryDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <span>暂无导入批次，上传模板后将在此显示历史记录</span>
        </template>
      </el-table>
      <el-pagination @current-change="handleHistoryPageChange" :current-page="history.page" :page-size="history.row"
        layout="total, prev, pager, next" :total="history.total" class="pagination"></el-pagination>
    </el-card>

    <!-- 导入对账 -->
    <el-card v-if="recon.show" class="box-card">
      <div slot="header" class="flex justify-between">
        <span>导入对账（批次号：{{ recon.logId }}）</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="_resetImport">重新导入</el-button>
      </div>

      <div v-if="recon.polling" class="recon-polling">
        <i class="el-icon-loading"></i>
        <span>正在处理导入数据，请稍候...（已等待 {{ recon.pollTimes * 3 }} 秒）</span>
      </div>

      <template v-else>
        <el-row :gutter="20" class="recon-counts">
          <el-col :span="6">
            <div class="recon-count success">
              <div class="num">{{ recon.stateDist.C || 0 }}</div>
              <div class="label">成功</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="recon-count warning">
              <div class="num">{{ recon.stateDist.S || 0 }}</div>
              <div class="label">跳过</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="recon-count danger">
              <div class="num">{{ recon.stateDist.F || 0 }}</div>
              <div class="label">失败</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="recon-count info">
              <div class="num">{{ recon.imageMissList.length }}</div>
              <div class="label">图片未匹配</div>
            </div>
          </el-col>
        </el-row>

        <el-alert v-if="recon.imageMissList.length > 0" type="warning" :closable="false" class="margin-top-sm"
          :title="'以下封面图在 zip 中未找到：' + recon.imageMissList.join('、')" description="未匹配图片的商品已按无图导入，可后续在商品管理中单独补充">
        </el-alert>

        <div class="flex justify-between margin-top-sm">
          <span class="fail-title">失败明细</span>
          <el-button size="small" @click="_downloadFailCsv" :disabled="recon.failList.length === 0">下载失败明细</el-button>
        </div>
        <el-table :data="recon.failList" border style="width: 100%" class="margin-top-sm">
          <el-table-column prop="detailId" label="明细ID" align="center" width="180"></el-table-column>
          <el-table-column prop="message" label="失败原因" align="center"></el-table-column>
          <el-table-column prop="createTime" label="时间" align="center" width="180"></el-table-column>
        </el-table>
        <el-pagination @current-change="handleFailPageChange" :current-page="recon.failPage" :page-size="20"
          layout="total, prev, pager, next" :total="recon.failTotal" class="pagination"></el-pagination>
      </template>
    </el-card>
  </div>
</template>

<script>
import { uploadProductImport } from '@/api/goods/productImportApi'
import { queryImportBatchDetail, queryImportBatches } from '@/api/goods/importBatchApi'
import { getShopId } from '@/api/shop/shopApi'

const EXCEL_MAX_SIZE = 20 * 1024 * 1024 // 20M
const ZIP_MAX_SIZE = 500 * 1024 * 1024 // 500M
const POLL_INTERVAL = 3000 // 轮询间隔 3 秒
const POLL_MAX_TIMES = 100 // 最多 100 次（5 分钟超时）

export default {
  name: 'ProductImport',
  data() {
    return {
      productImportInfo: {
        shopId: '',
        excelTemplate: '',
        zipFile: '',
        remark: ''
      },
      fileList: [],
      zipFileList: [],
      importing: false,
      recon: {
        show: false,
        logId: '',
        polling: false,
        pollTimes: 0,
        stateDist: {},
        imageMissList: [],
        failList: [],
        failTotal: 0,
        failPage: 1
      },
      pollTimer: null,
      history: {
        list: [],
        total: 0,
        page: 1,
        row: 10,
        loading: false
      }
    }
  },
  created() {
    let shopId = this.getShopId();
    this.productImportInfo.shopId = shopId
    this._queryHistory(1)
  },
  beforeDestroy() {
    this._clearPollTimer()
  },
  methods: {
    productImportValidate() {
      if (!this.productImportInfo.excelTemplate) {
        this.$message.error('文件不能为空')
        return false
      }
      if (!this.productImportInfo.shopId) {
        this.$message.error('还未入驻小区，请先入驻小区')
        return false
      }
      return true
    },
    _openDownloadHcExcelTemplate() {
      window.open('/import/hcmall.xlsx')
    },
    getExcelTemplate(file) {
      this.productImportInfo.excelTemplate = file.raw
    },
    getZipFile(file) {
      this.productImportInfo.zipFile = file.raw
      this.zipFileList = [file]
    },
    removeZipFile() {
      this.productImportInfo.zipFile = ''
      this.zipFileList = []
    },
    async _importData() {
      if (this.importing) {
        return
      }
      if (!this.productImportValidate()) {
        return
      }

      if (!this.checkFileType(this.productImportInfo.excelTemplate.name.split('.')[1])) {
        this.$message.error('不是有效的Excel格式')
        return
      }

      if (!this.checkFileSize(this.productImportInfo.excelTemplate.size, EXCEL_MAX_SIZE)) {
        this.$message.error('Excel文件大小不能超过20M')
        return
      }

      if (this.productImportInfo.zipFile) {
        if (!this.checkZipType(this.productImportInfo.zipFile.name)) {
          this.$message.error('图片压缩包仅支持 zip 格式')
          return
        }
        if (!this.checkFileSize(this.productImportInfo.zipFile.size, ZIP_MAX_SIZE)) {
          this.$message.error('图片压缩包大小不能超过500M')
          return
        }
      }

      const formData = new FormData()
      formData.append('uploadFile', this.productImportInfo.excelTemplate)
      formData.append('shopId', this.productImportInfo.shopId)
      formData.append('importAdapt', 'importProduct')
      formData.append('remark', this.productImportInfo.remark || '')
      if (this.productImportInfo.zipFile) {
        formData.append('zipFile', this.productImportInfo.zipFile)
      }

      this.importing = true
      try {
        const res = await uploadProductImport(formData)
        const logPo = this._parseLogPo(res && res.data)
        const logId = logPo && (logPo.logId || logPo.log_id)
        if (!logId) {
          this.$message.error('导入已提交，但未返回批次号，请到导入管理查看结果')
          return
        }
        this.$message.success('导入任务已提交，正在处理')
        this._startRecon(logId)
      } catch (error) {
        this.$message.error((error && error.msg) || '导入失败')
      } finally {
        this.importing = false
      }
    },
    // 解析 /assetImport 返回的 ResultVo.data（AssetImportLogPo，可能是对象或 JSON 字符串）
    _parseLogPo(data) {
      if (!data) {
        return null
      }
      if (typeof data === 'string') {
        try {
          return JSON.parse(data)
        } catch (e) {
          return null
        }
      }
      return data
    },
    _startRecon(logId) {
      this.recon = {
        show: true,
        logId: logId,
        polling: true,
        pollTimes: 0,
        stateDist: {},
        imageMissList: [],
        failList: [],
        failTotal: 0,
        failPage: 1
      }
      this._pollDetail()
    },
    _clearPollTimer() {
      if (this.pollTimer) {
        clearTimeout(this.pollTimer)
        this.pollTimer = null
      }
    },
    async _queryHistory(page) {
      if (!this.productImportInfo.shopId) {
        return
      }
      this.history.loading = true
      try {
        const res = await queryImportBatches({
          page: page,
          row: this.history.row,
          shopId: this.productImportInfo.shopId
        })
        // ResultVo 契约：records=总页数 total=总记录数 data=列表
        this.history.list = (res && res.data) || []
        this.history.total = (res && res.total) || 0
        this.history.page = page
        // 全部列固定宽度时剩余空间由 gutter 列填充，页签框架预渲染后容器宽度可能变化，
        // 数据到达后强制重排表格，避免表头表体错位、右侧大片空白
        this.$nextTick(() => {
          if (this.$refs.historyTable) {
            this.$refs.historyTable.doLayout()
          }
        })
      } catch (error) {
        console.error('查询历史导入批次失败:', error)
      } finally {
        this.history.loading = false
      }
    },
    handleHistoryPageChange(val) {
      this._queryHistory(val)
    },
    _viewHistoryDetail(row) {
      if (!row || !row.logId) {
        return
      }
      // 复用对账视图：历史批次已处理完，轮询一次即返回终态
      this._startRecon(row.logId)
    },
    async _pollDetail() {
      if (this.recon.pollTimes >= POLL_MAX_TIMES) {
        this.recon.polling = false
        this.$message.warning('等待导入处理超时（5分钟），当前进度已展示，可到导入管理查看最终结果')
        this._loadReconData()
        return
      }
      this.recon.pollTimes++
      try {
        const res = await queryImportBatchDetail({
          logId: this.recon.logId,
          page: 1,
          row: 1,
          shopId: this.productImportInfo.shopId
        })
        // api 层已解包一层，res 即 {details, stateDist}（自定义结构，非 ResultVo.data）
        const data = res || {}
        const stateDist = data.stateDist || {}
        const wCount = Number(stateDist.W || 0)
        // W=0 表示明细全部处理完，再确认主状态为 C（完成）即停止轮询
        if (wCount === 0) {
          const finished = await this._checkBatchFinished()
          if (finished) {
            this.recon.polling = false
            this.$message.success('导入处理完成')
            this._loadReconData()
            return
          }
        }
        this.pollTimer = setTimeout(() => {
          this._pollDetail()
        }, POLL_INTERVAL)
      } catch (error) {
        // 单次失败不中断轮询
        this.pollTimer = setTimeout(() => {
          this._pollDetail()
        }, POLL_INTERVAL)
      }
    },
    // 主批次状态 C=完成 视为处理完成；按 logId 精确查询，不再在前 20 条内 find
    async _checkBatchFinished() {
      try {
        const res = await queryImportBatches({
          page: 1,
          row: 1,
          logId: this.recon.logId,
          shopId: this.productImportInfo.shopId
        })
        const list = (res && res.data) || []
        const batch = list[0]
        // fail-closed：查不到批次视为未完成，继续轮询，绝不误判完成
        if (!batch) {
          return false
        }
        return batch.state === 'C'
      } catch (error) {
        return false
      }
    },
    async _loadReconData() {
      // 批次行：按 logId 精确查询取成功/跳过/失败计数与图片未匹配清单
      try {
        const res = await queryImportBatches({
          page: 1,
          row: 1,
          logId: this.recon.logId,
          shopId: this.productImportInfo.shopId
        })
        const list = (res && res.data) || []
        const batch = list[0]
        if (batch) {
          this.recon.stateDist = {
            C: batch.successCount || 0,
            S: batch.skipCount || 0,
            F: batch.errorCount || 0,
            W: batch.waitCount || 0
          }
          this.recon.imageMissList = this._parseImageMiss(batch.imageMissJson)
        }
      } catch (error) {
        console.error('查询批次结果失败:', error)
      }
      this._loadFailList(1)
    },
    _parseImageMiss(imageMissJson) {
      if (!imageMissJson) {
        return []
      }
      if (typeof imageMissJson === 'string') {
        try {
          const arr = JSON.parse(imageMissJson)
          return Array.isArray(arr) ? arr : []
        } catch (e) {
          return []
        }
      }
      return Array.isArray(imageMissJson) ? imageMissJson : []
    },
    async _loadFailList(page) {
      try {
        const res = await queryImportBatchDetail({
          logId: this.recon.logId,
          page: page,
          row: 20,
          state: 'F',
          shopId: this.productImportInfo.shopId
        })
        const details = (res && res.details) || {}
        this.recon.failList = details.data || details.list || []
        this.recon.failTotal = details.total || 0
        this.recon.failPage = page
      } catch (error) {
        console.error('查询失败明细失败:', error)
      }
    },
    handleFailPageChange(val) {
      this._loadFailList(val)
    },
    _downloadFailCsv() {
      const rows = this.recon.failList
      if (!rows || rows.length === 0) {
        this.$message.warning('暂无失败明细')
        return
      }
      const header = '明细ID,失败原因,时间'
      const lines = rows.map(item => {
        return [item.detailId, this._csvEscape(item.message), item.createTime].join(',')
      })
      const csv = '﻿' + header + '\n' + lines.join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = '导入失败明细_' + this.recon.logId + '.csv'
      link.click()
      URL.revokeObjectURL(link.href)
    },
    _csvEscape(value) {
      if (value === null || value === undefined) {
        return ''
      }
      const str = String(value)
      if (str.indexOf(',') > -1 || str.indexOf('"') > -1 || str.indexOf('\n') > -1) {
        return '"' + str.replace(/"/g, '""') + '"'
      }
      return str
    },
    _resetImport() {
      this._clearPollTimer()
      this.recon = {
        show: false,
        logId: '',
        polling: false,
        pollTimes: 0,
        stateDist: {},
        imageMissList: [],
        failList: [],
        failTotal: 0,
        failPage: 1
      }
      this.productImportInfo.excelTemplate = ''
      this.productImportInfo.zipFile = ''
      this.productImportInfo.remark = ''
      this.fileList = []
      this.zipFileList = []
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles()
      }
      if (this.$refs.zipUpload) {
        this.$refs.zipUpload.clearFiles()
      }
      // 返回上传页时刷新历史批次，刚导入的批次立即出现在列表
      this._queryHistory(1)
    },
    checkFileType(fileType) {
      const acceptTypes = ['xls', 'xlsx']
      return acceptTypes.includes(fileType)
    },
    checkZipType(fileName) {
      return /\.zip$/i.test(fileName)
    },
    checkFileSize(fileSize, maxSize) {
      return fileSize <= maxSize
    },
    getShopId() {
      console.log('getShopId');
      return getShopId()
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}

/* 仅作用于上传页"导入"按钮所在列：撑满整行后按钮右浮，避免 span=2 窄列按钮换行；
   不可写成全局 .el-col，会把对账区 4 个统计列(span=6)全部撑成整行竖排 */
.import-btn-col {
  width: 100%;
}

.recon-polling {
  text-align: center;
  padding: 40px 0;
  color: #909399;
  font-size: 14px;
}

.recon-polling i {
  margin-right: 8px;
  font-size: 18px;
}

.recon-counts {
  text-align: center;
}

.recon-count {
  border-radius: 4px;
  padding: 16px 0;
}

.recon-count .num {
  font-size: 28px;
  font-weight: bold;
  line-height: 1.4;
}

.recon-count .label {
  font-size: 13px;
  color: #909399;
}

.recon-count.success .num {
  color: #67C23A;
}

.recon-count.warning .num {
  color: #E6A23C;
}

.recon-count.danger .num {
  color: #F56C6C;
}

.recon-count.info .num {
  color: #909399;
}

.fail-title {
  font-size: 14px;
  font-weight: bold;
}

.margin-top-sm {
  margin-top: 10px;
}

.flex {
  display: flex;
}

.justify-between {
  justify-content: space-between;
  align-items: center;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
